<template>
    <div class="wrapper">
        <div class="main-panel">
            <div class="main-content">
                <div class="content-wrapper">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="card-block">
                                            <h2>Emergency certificates</h2>
                                            <table class="table table-responsive-sm">
                                                <thead>
                                                    <th>
                                                        {{ $t("labels.name") }}
                                                    </th>
                                                    <th>
                                                        {{ $t("labels.certificate") }}
                                                    </th>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="patient in patients" :key="patient._id">
                                                        <td>
                                                            {{ patient.name }} {{ patient.surname }}
                                                        </td>
                                                        <td>
                                                            <a :href="patient.certificate.signed_url" v-if="patient && patient.certificate && patient.certificate.signed_url">
                                                                <i class="fa fa-download font-medium-3 mr-2"></i>
                                                            </a>
                                                            <p v-else>
                                                                No certificate
                                                            </p>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import PatientService from '@/services/patient'

export default {
    data() {
        return {
            patients: []
        }
    },
    mounted: async function() {
        let result = await PatientService.index()
        if (result) {
            this.patients = result.data
        }
    }
}
</script>

